import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import './HeaderTable.scss';
import { isEqual } from 'lodash';
import ScrollComponent from './../../../common/ScrollComponent';

class MixHeaderTitle extends React.Component {
  state = {
    isShow: false,
  };
  div = document.createElement('div');
  rootRef = React.createRef();

  componentDidMount() {
    document.body.appendChild(this.div);
    document.addEventListener('mousedown', this.onMouseDown);
  }

  componentWillUnmount() {
    document.body.removeChild(this.div);
    document.removeEventListener('mousedown', this.onMouseDown);
  }

  onMouseDown = e => {
    const { isShow } = this.state;
    const isInTooltip = this.tooltipRef && this.tooltipRef.contains(e.target);
    if (!isInTooltip && isShow) {
      this.setState({
        isShow: false,
      });
    }
  };

  showDropDown = (bool = true) => {
    this.setState({
      isShow: bool,
    });
  };

  renderAction = () => {
    return (
      <button
        className="dropdown-toggle"
        type="button"
        aria-haspopup="true"
        onClick={() => this.showDropDown(true)}
        aria-expanded="false"
      >
        <i className="icon-caret ml-2" />
      </button>
    );
  };

  handleClick = key => () => {
    // e.preventDefault();
    // e.stopPropagation();
    const { changeIndustryTableDropDown } = this.props;
    this.showDropDown(false);
    changeIndustryTableDropDown(key);
  };

  setPopupStyle = el => {
    if (!el) {
      return;
    }
    this.tooltipRef = el;
    const {
      width,
      left,
      bottom,
    } = this.rootRef.current.getBoundingClientRect();
    el.style.setProperty('width', `${Math.max(width, 200)}px`, 'important');
    el.style.setProperty('position', 'fixed');
    el.style.setProperty('top', `${bottom}px`);
    el.style.setProperty('left', `${left}px`, 'important');
  };

  renderPopup = () => {
    const { isShow } = this.state;
    if (!isShow) {
      return null;
    }
    const className =
      'mix dropdown-menu dropdown-menu-left drop-th drop-mecus show';
    const { listIndustry, currentSelectedIndustryTable } = this.props;
    let scrollStyle = { maxHeight: 150 };
    return ReactDOM.createPortal(
      <div
        ref={this.setPopupStyle}
        className={className}
        aria-labelledby="dropdownMenuButton"
      >
        <ScrollComponent appendStyle={scrollStyle}>
          {listIndustry.length > 0 &&
            listIndustry.map((key, index) => {
              const isSelected = isEqual(currentSelectedIndustryTable, key);
              const clsName = isSelected
                ? 'dropdown-item active'
                : 'dropdown-item';
              return (
                <div
                  className={clsName}
                  key={index}
                  onClick={this.handleClick(key)}
                  style={{
                    textTransform: 'capitalize',
                    fontSize: 12,
                    cursor: 'pointer',
                  }}
                >
                  {key.icbName}
                </div>
              );
            })}
        </ScrollComponent>
      </div>,
      this.div,
    );
  };

  render() {
    const { children } = this.props;
    const title = I18n.t(children);

    return (
      <div ref={this.rootRef}>
        {title}
        <div className="dropdown drop-sort">
          {this.renderAction()}
          {this.renderPopup()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(MixHeaderTitle);
